import {
  DocumentAction,
  DocumentActionButton,
  DocumentColumnProperties,
  DocumentListItem,
} from '@/models/documents/document-list.model';
import { TableColumn } from '@/models/common/table.model';
import { AlignOptions } from '@/models/common/align-options.model';
import { payoutOrderColumnLabel } from '@/constants/payout-order/payout-order-list-column.constant';

export const documentColumnLabel: Record<string, string> = {
  [DocumentColumnProperties.CREATED_AT]: 'Time passed',
  [DocumentColumnProperties.WHITELABEL_SLUG]: 'Brand',
  [DocumentColumnProperties.PLAYER]: 'Player',
  [DocumentColumnProperties.FILES]: 'Files',
  [DocumentColumnProperties.ACTIONS]: 'Actions',
};

export const documentActionMap: Record<DocumentAction, DocumentActionButton> = {
  [DocumentAction.TAKE]: {
    label: 'Take',
    type: 'success',
  },
  [DocumentAction.DROP]: {
    label: 'Drop',
    type: 'danger',
  },
  [DocumentAction.FORCE_TAKE]: {
    label: 'Force take',
    type: 'danger',
  },
};

export const documentColumnsList: Array<TableColumn<DocumentListItem>> = [
  {
    label: documentColumnLabel[DocumentColumnProperties.CREATED_AT],
    prop: DocumentColumnProperties.CREATED_AT,
    width: 100,
  },
  {
    label: documentColumnLabel[DocumentColumnProperties.WHITELABEL_SLUG],
    prop: DocumentColumnProperties.WHITELABEL_SLUG,
    formatter: (row: DocumentListItem) => row[DocumentColumnProperties.WHITELABEL_SLUG].toUpperCase(),
    width: 150,
  },
  {
    label: documentColumnLabel[DocumentColumnProperties.PLAYER],
    prop: DocumentColumnProperties.PLAYER_EMAIL,
    minWidth: 200,
  },
  {
    label: documentColumnLabel[DocumentColumnProperties.FILES],
    prop: DocumentColumnProperties.FILES,
    width: 130,
    align: AlignOptions.CENTER,
  },
  {
    label: payoutOrderColumnLabel[DocumentColumnProperties.ACTIONS],
    prop: DocumentColumnProperties.ACTIONS,
    width: 120,
    fixed: AlignOptions.RIGHT,
    align: AlignOptions.CENTER,
  },
];
